import axiosInstance from "./api";
import TokenService from "./token.service";

//setup instersptor where user is logined in itends token to auth server for each request 
const setup = (store) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = TokenService.getLocalAccessToken();
      if (token) {
        config.headers["Authorization"] = 'Bearer ' + token;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  //setup interceptor to check if token is expired and refresh it
  axiosInstance.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      const originalConfig = err.config;
      // if (originalConfig.url !== "/auth/signin" && err.response) {
      //   // Access Token was expired


      if (err.response.status === 401 && !originalConfig._retry && originalConfig.url != undefined) {
        originalConfig._retry = true;

        try {

          let params = new URLSearchParams();
          params.append('grant_type', 'refresh_token');
          params.append('refresh_token', TokenService.getLocalRefreshToken());




          const rs = await axiosInstance({
            method: 'POST',
            baseURL: 'https://vop.olympusmarinegroup.com:8082/oauth/token',
            auth: { username: 'cantapermevop', password: '5799E092FB55679B69A28735859893410F761FD1872EF63432870ED6521CCA06' },
            headers: {
              "Content-type": "application/x-www-form-urlencoded; charset=utf-8"
            },
            data: params
          })





          store.dispatch('refreshToken', rs.data);
          TokenService.updateLocalAccessToken(rs.data);

          return axiosInstance(originalConfig);


        } catch (_error) {

          return Promise.reject(_error);
        }




      }


      return Promise.reject(err);
    }
  );
};

export default setup;